import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export function formatError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export const BRAND = {
  logoSquare: "https://customer-assets-v7afamib.emergentagent.net/job_a5aaf44d-5cbb-473b-9cd8-b887340c8392/artifacts/wo55qtbk_F622897E-DEE9-4CB9-9616-6B76936B103F.png",
  logoCircle: "https://customer-assets-v7afamib.emergentagent.net/job_a5aaf44d-5cbb-473b-9cd8-b887340c8392/artifacts/816h6rc6_84AF15F0-2B24-40DC-928D-9073C2033CFE.png",
  logoIconsRow: "https://customer-assets-v7afamib.emergentagent.net/job_a5aaf44d-5cbb-473b-9cd8-b887340c8392/artifacts/sh0yxzqr_99F32376-7C22-435B-ACF6-530C2257AAD3.png",
  logoHorizontal: "https://customer-assets-v7afamib.emergentagent.net/job_a5aaf44d-5cbb-473b-9cd8-b887340c8392/artifacts/rjsfthxn_778507F4-21AB-4307-93D5-4E86ED6D7879.png",
  heroImage: "https://images.pexels.com/photos/11655091/pexels-photo-11655091.jpeg",
  groupImage: "https://images.unsplash.com/photo-1755549746560-f56c7bd0c82f",
  corporateImage: "https://images.pexels.com/photos/8068807/pexels-photo-8068807.jpeg",
  aboutImage: "https://images.unsplash.com/photo-1775761087082-0d2c4f06496a",
  email: "info@kenmarqsafety.com",
  phone: "(610) 555-0100",
  address: "Bethlehem, PA 18018",
  instagram: "https://instagram.com/kenmarqsafety",
  facebook: "https://facebook.com/kenmarqsafety",
};
